export default {
  homePara:
    "La localizzazione della lingua è il processo di adattamento della traduzione di un prodotto a uno specifico paese o regione. È la seconda fase di un più ampio processo di traduzione del prodotto e adattamento culturale per tenere conto delle differenze in mercati distinti, un processo noto come internazionalizzazione e localizzazione",
  aboutPara:
    "Questo tutorial ha lo scopo di rendere semplice la localizzazione. Sebbene ci siano molti tutorial disponibili su Internet. Ma questo ti insegnerà il concetto in modo semplice. Puoi utilizzare direttamente questo codice per il tuo software. Ho usato gli hook 'Rreact', che ora è lo standard del settore del software. Puoi seguire il mio blog per ottenere più articoli relativi all'interfaccia utente che ti renderanno uno sviluppatore migliore dell'interfaccia utente. {0}",
  changeLanguage: "Cambia la tua lingua",
  name: "Nome",
  age: "Età",
  address: "Indirizzo",
  contactNo: "Numero di contatto",
  save: "Salva",
  formPara: "Per favore, inserisci qui i tuoi dati personali.",
  dynamicValue: "Dynamic Value- {randomNumber} {date}",
};
